import { Button } from '@cleartax/wg-library-button';
import { Text } from '@cleartax/wg-library-typography';
import { useState } from 'react';
import {
  THeader,
  THeaderCategory
} from '../../../../../../pages/services/[planSeoSlug]/api/types';
import { trackAction } from '../../../../../utils';
import { CategoryDropDownContent } from './category-dropdown-content';
import styles from './index.module.css';

interface ICategoryDropDown {
  categoryData: THeaderCategory | null;
  className?: string;
}

/**
 * We have 3 columns, THeaderCategory is of recursive type
 * where each category can have a list of subcategories.
 * Section 1 & 2 are lists of categories, where as section 3 is
 * the final selected category.
 *
 * categoryData --(children)-> categoryL1 --(children)-> categoryL2 -> SelectedL2Catgory
 *
 * @param - `categoryData` - The root category *
 * @param - `className` - classnames
 *
 */
export const CategoryDropDown: React.FC<ICategoryDropDown> = ({
  categoryData,
  className = '',
}) => {
  const categoryL1 = categoryData ? categoryData.subMenu : [];
  const [categoryL2, setCategoryL2] = useState<THeader>([]);
  const [categoryL3, setCategoryL3] = useState<THeaderCategory>();

  return (
    <div
      className={`${className}`}
      role="menu"
      aria-orientation="vertical"
      aria-labelledby="menu-button"
      tabIndex={-1}
    >
      <div className="flex w-full bg-white pb-6 rounded-b-lg">
        <div className={styles.categoryContainer}>
          <CategoryDropDownContent
            categoryList={categoryL1}
            categoryL2Setter={setCategoryL2}
            categroyL3Setter={setCategoryL3}
            level="L1"
          />
        </div>
        {categoryL2.length ? (
          <div
            className={`${styles.categoryContainer} bg-white border-l-sm border-l-grey-300`}
          >
            <CategoryDropDownContent
              categoryList={categoryL2}
              categroyL3Setter={setCategoryL3}
              level="L2"
            />
          </div>
        ) : null}
        {categoryL3 ? (
          <div className={`px-2 ${styles.categoryContainer}`}>
            <Text
              weight="bold"
              textSize="base"
              type="p"
              className="text-brand-1000 pt-3"
            >
              {categoryL3.name}
            </Text>
            <Text
              weight="medium"
              textSize="sm"
              type="p"
              className="text-grey-600 mb-6 pt-5"
            >
              {categoryL3.description}
            </Text>
            <Text
              type="a"
              href={`/services/${categoryL3.seoSlug}/c`}
              onClick={() => {
                trackAction('click', '', {
                  label: `top_nav_menu_item_${categoryL3.seoSlug}`,
                });
              }}
            >
              <Button rounded="md" variant="hollowBlue">
                {'View products'}
              </Button>
            </Text>
          </div>
        ) : null}
      </div>
    </div>
  );
};
